import { Box, FormLabel, Heading, VStack } from "@chakra-ui/react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { closeCreatePaymentModel } from "../../../../modules/admin-modules/models/Actions";
import { getAllCoursesRequest } from "../../../../modules/superadmin-modules/courses/Actions";
import {
  createPaymentRequest,
  editPaymentRequest,
} from "../../../../modules/superadmin-modules/payment/Actions";

const AddPayment = ({ isAdd, selectedData, setSelectedData }) => {
  const dispatch = useDispatch();
  const courses = useSelector((state) => state.courses.courses);

  const openEvent = useSelector((state) => state.model.isOpen19);
  const isLoading = useSelector((state) => state.events.isLoading);

  console.log(openEvent, "openEvent");
  useEffect(() => {
    if (openEvent) {
      dispatch(getAllCoursesRequest());
    }
  }, [openEvent]);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: !isAdd ? selectedData : {},
    shouldUnregister: true,
  });
  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        دفع
      </Heading>
    </Box>
  );
  const onSubmit = (data) => {
    const body = {
      ...data,
    };
    const action = () => {
      dispatch(closeCreatePaymentModel());
      setSelectedData({});
      reset();
    };
    if (isAdd) {
      dispatch(createPaymentRequest(body, action));
    } else {
      dispatch(
        editPaymentRequest({
          id: selectedData?.id,
          formdata: body,
          action: action,
        })
      );
    }
  };

  const coursesOptions = courses?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const closeFunc = () => {
    dispatch(closeCreatePaymentModel());
    setSelectedData({});
    reset();
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openEvent}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack dir="rtl" w="100%" alignItems="flex-start" spacing={4}>
          <MainInput
            label=" الاسم"
            error={errors?.name?.message}
            register={register}
            name="name"
            type="text"
            defaultValues={selectedData?.name}
          />
          <MainInput
            label="مبلغ الدفع"
            error={errors?.value?.message}
            register={register}
            name="value"
            type="number"
            defaultValues={selectedData?.value}
          />
          <VStack dir="rtl" w="100%" alignItems="flex-start" spacing={4}>
            <FormLabel>الدورات : </FormLabel>
            <Box width="100%">
              <Select
                options={coursesOptions}
                onChange={(data) => setValue("course_id", data.value)}
                defaultValue={{
                  value: selectedData?.course?.id,
                  label: selectedData?.course?.name,
                }}
              />
            </Box>
          </VStack>
        </VStack>
      </form>
    </MainModel>
  );
};

export default AddPayment;
